import YouTubePlayer from 'youtube-player';
import playSvg from '../../../../web/assets/images/play.svg?raw';
class IframeYoutube extends HTMLElement {
  constructor() {
    super();

    this.classList.add('media')
    this.videoId = this.getAttribute('video-id')
    this.videoKey = this.getAttribute('video-key')
    this.defaultCover = this.getAttribute('default-cover')
    this.posterUrl = 'https://img.youtube.com/vi/' + this.videoId + '/maxresdefault.jpg'

    this.posterMarkup = `<div class="iframe__poster figure figure-gradient">
      <img
        src="${this.posterUrl}"
        width="1280"
        height="720"
        alt="Poster"
        class="iframe__img"
        loading="lazy">
      <button
        class="button iframe__play"
        type="button"
        value="Play Youtube Video"
      >
        <i class="icon icon-play">
          ${playSvg}
        </i>
        <span class="visually-hidden">Play Youtube Video</span>
      </button>
    </div>`;

    // Create a shadow root
    // const shadow = this.attachShadow({mode: 'open'});

    const iframeContainer = document.createElement('div');
    iframeContainer.setAttribute('class', 'iframe-container');

    // Create player element
    const wrapper = document.createElement('div');
    wrapper.setAttribute('id', `player-${this.videoKey}`);
    iframeContainer.appendChild(wrapper);

    iframeContainer.insertAdjacentHTML("beforeend", this.posterMarkup)

    this.appendChild(iframeContainer);

    this.player = YouTubePlayer(`player-${this.videoKey}`, {
      videoId: this.videoId,
      playerVars: {
        rel: 0
      }
    });

    this.playButton = this.querySelector(".iframe__play")
    this.poster = this.querySelector(".iframe__poster")

    this.playButton.addEventListener("click", evt => {
      evt.preventDefault()
      this.poster.classList.add("iframe__poster--playing")
      this.player.playVideo()
    })

    this.player.on('stateChange', (evt) => {
      if (evt.data === 0) {
        this.poster.classList.remove("iframe__poster--playing")
      }
    })

    const imgEl = iframeContainer.querySelector('.iframe__img')
    const sdUrl = 'https://img.youtube.com/vi/' + this.videoId + '/sddefault.jpg'

    this.calculateSize(this.posterUrl)
        .then(data => {
          if (data.width === 120 && data.height === 90) {
            return this.calculateSize(sdUrl).then(sdData => {
              imgEl.src = (sdData.width === 120 && sdData.height === 90)
                ? this.defaultCover
                : sdUrl
            })
          }
        })
        .catch((error) => {
          console.error(error)
        })

  }

  calculateSize(url) {
    return new Promise(function(resolve, reject) {
      const image = document.createElement('img');
      image.addEventListener('load', function(e) {
        resolve({
          width: e.target.width,
          height: e.target.height,
        });
      });

      image.addEventListener('error', function() {
        reject('error');
      });

      image.src = url;
    });
  }
}

export default IframeYoutube
